import { colors } from '../../shared/styles';

export const styles = {
  label: {
    fontSize: 17,
    color: colors.darkGrey4,
    fontFamily: 'ProximaNovaRegular',
    width: 500
  },
  inputStyle: {
    fontFamily: 'ProximaNovaRegular',
    width: '100%',
    float: 'left',
    minHeight: 25,
    border: 'none',
    fontSize: 16,
    borderBottom: `1px solid ${colors.lightGrey4}`
  },
  selectStyle: {
    minHeight: 25
  },
  invalidInput: {
    color: colors.error,
  },
  customWidth: {
    width: 200,
  },
  loading: {
    width:'100%',
    height: 150
  },
  addToCalNote: {
    fontSize: 12,
    color: colors.grey
  },
  startListBody: {
    fontSize: 17,
    color: colors.darkGrey4,
    fontFamily: 'ProximaNovaRegular',
    paddingLeft: 14,
    paddingRight: 14,
    marginTop: 0,
    marginBottom: 24
  }
};



/** WEBPACK FOOTER **
 ** ./components/eventCalendar/styles.js
 **/